import React from 'react';

import styled from 'styled-components';

import Button from 'components/lib/Button';
import Modal from 'components/lib/Modal';
import { joinWithAnd } from 'utils/helpers/string';

const Subtitle = styled.div`
  font-family: var(--font-regular);
  font-size: 14px;
  font-weight: 500;
  color: var(--dark-blue);
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px 0 25px;
  font-size: 16px;
  line-height: 1.6;
`;

const StyledButton = styled(Button)`
  min-width: 140px;
  height: 40px;
`;

type Props = {
  open: boolean;
  communityName?: string;
  regeneratedLabels: string[];
  onClose: () => void;
};

const AICIRegenerationStartedModal = ({ open, communityName, regeneratedLabels, onClose }: Props) => (
  <Modal
    open={open}
    centered
    width={620}
    className="compact bare-header"
    data-test-id="aici-regeneration-started-modal"
    title={
      <div>
        <div>Regeneration started</div>
        <Subtitle>{communityName}</Subtitle>
      </div>
    }
    onCancel={onClose}
    footer={
      <StyledButton type="primary" data-test-id="aici-regeneration-started-ok" onClick={onClose}>
        OK
      </StyledButton>
    }
  >
    <Body>
      <div>We are regenerating {joinWithAnd(regeneratedLabels)}.</div>
      <div>
        This usually takes about 10 minutes. Please come back later to see the updated results. Until then, the current
        results stay on the page.
      </div>
    </Body>
  </Modal>
);

export default AICIRegenerationStartedModal;
